module.exports = __webpack_public_path__ + "static/media/fruits_47.3ae1ab60.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_47.csv
// module id = 714
// module chunks = 0